/* tslint:disable */
/* eslint-disable */
export enum ProgramGraphType {
  AllTargets = 0,
  FilteredByTargetStatus = 1,
  FilteredByTargetType = 2,
  SelectedTargets = 3,
  TargetsMasteredCumulative = 4
}
